import * as angular from "angular";
import {BringozToastService} from "../../commons/services/bringoz-toast.service";

export class ShippersAlertsService {

  /* @ngInject */
  constructor(private bringozToastService: BringozToastService) {
  }

  // UPDATE PASSWORD //
  updatePasswordSuccess(shipper?) {
    const message = {
      body: 'SHIPPER_UPDATE PASSWORD_SUCCESS'
    };
    let name;
    if (shipper) {
      name = shipper.firstName + " " + shipper.lastName;
    }
    return this.bringozToastService.success(message, {name: name})
  }

  updatePasswordError() {
    const message = {
      body: 'SHIPPER_UPDATE PASSWORD_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // DELETE ONE //
  deleteOneSuccess(shipper) {
    const message = {
      body: 'X_SHIPPER_DELETE_ONE_SUCCESS'
    };
    let name;
    if (shipper) {
      name = shipper.firstName + " " + shipper.lastName;
    }
    return this.bringozToastService.success(message, {name: name})
  }

  deleteOneError() {
    const message = {
      body: 'SHIPPER_DELETE_ONE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }


  // CREATE SHIPPER API
  addShipperApiSuccess() {
    const message = {
      body: 'ADD_SHIPPER_API_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  addShipperApiError() {
    const message = {
      body: 'ADD_SHIPPER_API_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

}

angular
  .module('bringoz.admin.shippers')
  .service('shippersAlertsService', ShippersAlertsService);
